import PATHS from 'constants/paths';

import Button from 'style-guide/Button';

const SignInButton = () => (
  <div className='d-flex authentication-buttons'>
    <Button variant='link' className='linkButton' to={PATHS.SIGN_IN}>
      Sign in
    </Button>

    <Button variant='primary' className='sign-up' to={PATHS.SIGN_UP}>
      Sign up
    </Button>
  </div>
);

export default SignInButton;
